import { useContext } from "react";
import { SuperuserContext } from "./SuperuserContextDef";
import type { SuperuserContextValue } from "./superuser.types";
import { useUser } from "./UserContext";

export const useImpersonation = () => useContext(SuperuserContext);

export const useSuperuserMode = (): SuperuserContextValue => {
  const context = useContext(SuperuserContext);
  const { userInfo } = useUser();
  if (!userInfo?.is_superuser) {
    return {
      isSuperuserMode: false,
      setIsSuperuserMode: () => {},
      impersonatedUser: null,
      startImpersonation: async () => {},
      stopImpersonation: async () => {},
      impersonatedRole: null,
      startRoleImpersonation: async () => {},
      stopRoleImpersonation: async () => {},
    };
  }
  return context;
};
